import { render, staticRenderFns } from "./mainNew.vue?vue&type=template&id=5d98f82d&scoped=true&"
import script from "./mainNew.vue?vue&type=script&lang=js&"
export * from "./mainNew.vue?vue&type=script&lang=js&"
import style0 from "./mainNew.vue?vue&type=style&index=0&id=5d98f82d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d98f82d",
  null
  
)

export default component.exports